// Le web n'a pas d'OTA : il sert toujours le dernier déploiement.
export const runningUpdateGroup = () => null
export const runningBundle = () => "web"
